// Form start block (templates/_blocks/_contentMatrix/_formStartBlock.twig, ADR 0031): the visitor's email is handed to the
// form page in sessionStorage, so it never appears in a URL, analytics page view, server log or the Blitz cache key.
// FormEmbed.js picks it up there. If storage is blocked, the form's native GET (`?email=`) carries it instead.
(function() {
    var KEY = 'wghi_prefill';

    document.addEventListener('submit', function(event) {
        var form = event.target;
        if ( !form.matches || !form.matches('[data-form-start]') ) {
            return;
        }
        var email = form.elements.email ? form.elements.email.value.trim() : '';
        try {
            window.sessionStorage.setItem(KEY, JSON.stringify({ email: email, ts: Date.now() }));
        } catch (e) {
            return;
        }
        event.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'form_start_submit' });
        window.location.assign(form.action);
    });
})();
